import OBase from './OBase';

import * as Geometry from '../geometry';

export default class NumberSlider extends OBase {
  constructor (src) {
    super(src);

    this.ghSliderObject = src.ghGeometryObject;
  }

  update () {
    let output = this.getGenericObjectOutput('Number Slider');

    let value = this.ghSliderObject.value;

    let tree = new Geometry.DataTree();
    tree.add(value, new Geometry.GHPath(0));
    output.value = tree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/NumberSlider.js